// extracted by mini-css-extract-plugin
module.exports = {"section":"_2-J0q"};